;(function () {
  'use strict'

  angular
    .module('contrast.virtual-patch')
    .factory(
      'virtualPatchService',
      function virtualPatchServiceFactory(
        $translate,
        ServiceUtils,
        VirtualPatchDeleteModalService,
        virtualPatchApiConfig,
        FeaturesService,
        ApplicationService,
        LanguagesService,
        VIRTUAL_PATCH,
        AGENT_FEATURE,
        NOTIFICATION_TYPE_OPTIONS
      ) {
        'ngInject'

        return {
          isValidVirtualPatch: isValidVirtualPatch,
          getApplicationMode: getApplicationMode,
          getApplyTo: getApplyTo,
          getLanguages: getLanguages,
          convertLanguageEnums: convertLanguageEnums,
          getValidLanguages: getValidLanguages,
          getApplications: getApplications,
          addApplication: addApplication,
          removeApplication: removeApplication,
          transformPatchSettings: transformPatchSettings,
          toggleEnabled: toggleEnabled,
          getVirtualPatch: getVirtualPatch,
          getVirtualPatches: getVirtualPatches,
          addVirtualPatch: addVirtualPatch,
          editVirtualPatch: editVirtualPatch,
          deleteVirtualPatch: deleteVirtualPatch,
          prepopVirtualPatch: prepopVirtualPatch,
          getQuickFilters: getQuickFilters,
          openDeleteModal: VirtualPatchDeleteModalService.open
        }

        /**
         * @param patch
         * @returns {boolean}
         */
        function isValidVirtualPatch(patch) {
          if (patch === '') {
            return false
          }

          switch (patch.applyTo) {
            case VIRTUAL_PATCH.APPLY_TO.APPLICATIONS:
              if (angular.isUndefined(patch.apps) || patch.apps.length === 0) {
                return false
              }
              break

            case VIRTUAL_PATCH.APPLY_TO.TECHNOLOGIES:
              if (
                angular.isUndefined(patch.technologies) ||
                patch.technologies.length === 0
              ) {
                return false
              }
              break

            case VIRTUAL_PATCH.APPLY_TO.LANGUAGES:
              if (
                angular.isUndefined(patch.languages) ||
                patch.languages.length === 0
              ) {
                return false
              }
              break

            default:
              return false
          }

          var i = 0,
            condition

          for (; i < patch.criterias.length; i++) {
            condition = patch.criterias[i]
            switch (condition.attribute) {
              case VIRTUAL_PATCH.CONDITIONS.ENUM.MATCHES:
              case VIRTUAL_PATCH.CONDITIONS.ENUM.DOES_NOT_MATCH:
              case VIRTUAL_PATCH.CONDITIONS.ENUM.CONTAINS:
              case VIRTUAL_PATCH.CONDITIONS.ENUM.DOES_NOT_EQUAL:
                if (condition.value === '') {
                  return false
                }
                break
              case VIRTUAL_PATCH.CONDITIONS.ENUM.DOES_NOT_CONTAIN:
              case VIRTUAL_PATCH.CONDITIONS.ENUM.EQUALS:
                if (condition.value === '' || condition.name === '') {
                  return false
                }
                break
              default:
                return false
            }
          }

          return true
        }

        function getApplicationMode(patch) {
          if (patch.applyTo === VIRTUAL_PATCH.APPLY_TO.APPLICATIONS) {
            if (angular.isDefined(patch.apps) && patch.apps[0] === 'ALL') {
              return VIRTUAL_PATCH.APPLICATION_MODE.ALL
            }
            return VIRTUAL_PATCH.APPLICATION_MODE.INDIVIDUAL
          } else if (patch.applyTo === VIRTUAL_PATCH.APPLY_TO.TECHNOLOGIES) {
            return VIRTUAL_PATCH.APPLICATION_MODE.TECHNOLOGY
          } else if (patch.applyTo === VIRTUAL_PATCH.APPLY_TO.LANGUAGES) {
            return VIRTUAL_PATCH.APPLICATION_MODE.LANGUAGE
          }
        }

        function getApplyTo(applicationMode) {
          if (
            applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.ALL ||
            applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.INDIVIDUAL
          ) {
            return VIRTUAL_PATCH.APPLY_TO.APPLICATIONS
          } else if (
            applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.TECHNOLOGY
          ) {
            return VIRTUAL_PATCH.APPLY_TO.TECHNOLOGIES
          } else if (VIRTUAL_PATCH.APPLICATION_MODE.LANGUAGE) {
            return VIRTUAL_PATCH.APPLY_TO.LANGUAGES
          }
        }

        function getLanguages(languages) {
          var convertedLangs = []
          _.each(languages, function (lang) {
            convertedLangs.push(LanguagesService.getLanguage(lang).value)
          })
          return convertedLangs
        }

        function convertLanguageEnums(languages) {
          var convertedLangs = []
          _.each(languages, function (lang) {
            var langObj = LanguagesService.getLanguage(lang)
            if (langObj) {
              convertedLangs.push(langObj.name)
            }
          })
          return convertedLangs
        }

        function getValidLanguages() {
          return FeaturesService.getEnabledLanguagesByAgentFeature(
            AGENT_FEATURE.VIRTUAL_PATCHES
          ).then(function (languages) {
            return _.map(languages, function (lang) {
              return lang[0]
            })
          })
        }

        function getApplications(validLanguages) {
          var transl = {
            title_allApplications: $translate.instant('title_allApplications')
          }

          return ApplicationService.getApplicationBase(
            false,
            validLanguages
          ).then(function (applications) {
            var count = applications.length
            var appsSelect = [
              {
                value: NOTIFICATION_TYPE_OPTIONS.ALL,
                name: transl.title_allApplications + ' (' + count + ')'
              }
            ]

            _.each(applications, function (app) {
              appsSelect.push({
                value: app.app_id,
                name: app.name
              })
            })

            return appsSelect
          })
        }

        function addApplication(applications, model) {
          if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
            applications = [NOTIFICATION_TYPE_OPTIONS.ALL]
          } else {
            applications = _.filter(applications, function (app) {
              return app !== NOTIFICATION_TYPE_OPTIONS.ALL
            })
          }

          return applications
        }

        function removeApplication(applications, model) {
          if (model !== NOTIFICATION_TYPE_OPTIONS.ALL) {
            applications = _.filter(applications, function (app) {
              return app !== NOTIFICATION_TYPE_OPTIONS.ALL
            })
          }

          if (applications.length === 0) {
            applications = [NOTIFICATION_TYPE_OPTIONS.ALL]
          }

          return applications
        }

        function transformPatchSettings(patch) {
          var applicationMode = getApplicationMode(patch)
          var transformedPatch = {
            name: patch.name,
            application_mode: applicationMode,
            description: patch.description,
            criterias: patch.criterias
          }

          if (applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.INDIVIDUAL) {
            transformedPatch.applications = patch.apps
          } else if (
            applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.TECHNOLOGY
          ) {
            transformedPatch.technologies = patch.technologies
          } else if (
            applicationMode === VIRTUAL_PATCH.APPLICATION_MODE.LANGUAGE
          ) {
            transformedPatch.languages = getLanguages(patch.languages)
          }

          return transformedPatch
        }

        /**
         * @param patchUuid
         * @param environment
         * @returns {Promise}
         */
        function toggleEnabled(patchUuid, environment) {
          return virtualPatchApiConfig
            .toggleEnabled(patchUuid, environment)
            .then(ServiceUtils.handleResolve('data'))
            .catch(ServiceUtils.handleError)
        }

        /**
         * @param patchUuid
         * @returns {Promise}
         */
        function getVirtualPatch(patchUuid) {
          return virtualPatchApiConfig
            .getVirtualPatch(patchUuid)
            .then(ServiceUtils.handleResolve('data.patch'))
            .catch(ServiceUtils.handleError)
        }

        function getVirtualPatches(filters) {
          return virtualPatchApiConfig
            .getVirtualPatches(filters)
            .then(ServiceUtils.handleResolve('data'))
            .catch(ServiceUtils.handleError)
        }

        /**
         * @param settings
         * @returns {Promise}
         */
        function addVirtualPatch(settings) {
          return virtualPatchApiConfig
            .addVirtualPatch(settings)
            .then(
              ServiceUtils.handleResolve('data', {
                log: ServiceUtils.LOGGER.SUCCESS
              })
            )
            .catch(ServiceUtils.handleError)
        }

        /**
         * @param patchUuid
         * @param settings
         * @returns {Promise}
         */
        function editVirtualPatch(patchUuid, settings) {
          return virtualPatchApiConfig
            .editVirtualPatch(patchUuid, settings)
            .then(
              ServiceUtils.handleResolve('data', {
                log: ServiceUtils.LOGGER.SUCCESS
              })
            )
            .catch(ServiceUtils.handleError)
        }

        /**
         * @param patchUuid
         * @returns {Promise}
         */
        function deleteVirtualPatch(patchUuid) {
          return virtualPatchApiConfig
            .deleteVirtualPatch(patchUuid)
            .then(
              ServiceUtils.handleResolve('data', {
                log: ServiceUtils.LOGGER.SUCCESS
              })
            )
            .catch(ServiceUtils.handleError)
        }

        /**
         * @param eventId
         * @returns {Promise}
         */
        function prepopVirtualPatch(eventId) {
          return virtualPatchApiConfig
            .prepopVirtualPatch(eventId)
            .then(ServiceUtils.handleResolve('data.patch'))
            .catch(ServiceUtils.handleError)
        }

        function getQuickFilters(filters) {
          return virtualPatchApiConfig
            .getQuickFilters(filters)
            .then(ServiceUtils.handleResolve('data.filters'))
            .catch(ServiceUtils.handleError)
        }
      }
    )
})()
